import { IMG } from "./services";
export const sectors = [
  {
    "slug": "real-estate-marketing",
    "azSlug": "dasinmaz-emlak-marketinqi",
    "name": "Real Estate",
    "h1": "Marketing & Sales Systems for Real Estate",
    "seoTitle": "Real Estate Marketing & Sales Strategy | YUXEL",
    "seoDesc": "Marketing strategy, digital advertising, lead generation and sales systems for residential developments and business centres.",
    "intro": "Developers do not have an advertising problem. They have a demand-to-sale problem: enquiries that never become viewings, viewings that never become contracts, and a price list that erodes with every campaign. YUXEL builds the whole chain — positioning, digital advertising, lead generation and sales process — as one commercial system measured on sold square metres.",
    "cover": "/cases/baki-evleri/aerial.webp",
    "pillars": [
      {
        "t": "Concept & positioning",
        "d": "A market position and value story for the development — so buyers compare you on meaning, not on price per square metre."
      },
      {
        "t": "Digital advertising & lead generation",
        "d": "Performance campaigns, audience segmentation and media planning managed on sales outcomes, not enquiry volume."
      },
      {
        "t": "Sales process & management",
        "d": "Enquiry handling, viewing conversion, follow-up discipline and reporting rebuilt as a repeatable sales system."
      },
      {
        "t": "Commercial optimisation",
        "d": "The advertising → enquiry → sale → revenue chain instrumented and optimised weekly, so spend follows what actually sells."
      }
    ],
    "stats": [
      {
        "v": "≈40%",
        "l": "BAKI EVLƏRİ: sales price increase in 10 months"
      },
      {
        "v": "≈60%",
        "l": "ART TOWER: apartments sold in 12 months; YUXEL managed digital planning and advertising"
      },
      {
        "v": "≈70%",
        "l": "25 PLAZA: occupancy within 4 months after handover"
      }
    ],
    "serviceSlugs": [
      "marketing-strategy",
      "sales-commercial-systems",
      "brand-strategy",
      "business-analytics"
    ],
    "caseSlugs": [
      "baki-evleri",
      "art-tower",
      "25-plaza",
      "zenith-plaza",
      "fexri-tower"
    ],
    "ctaTitle": "Launching or selling a development?",
    "ctaSub": "Book a consultation — we'll map the demand engine, the sales process and the return before the first campaign runs."
  },
  {
    "slug": "horeca-marketing",
    "azSlug": "horeca-marketinq",
    "name": "HoReCa & Entertainment",
    "h1": "Marketing Systems for HoReCa & Entertainment Businesses",
    "seoTitle": "Restaurant & HoReCa Marketing Strategy | YUXEL",
    "seoDesc": "Marketing systems for restaurants, hospitality and entertainment businesses — built to grow guest flow, sales and repeat visits.",
    "intro": "Restaurants, venues and hospitality groups live on frequency: how many guests arrive, how much they spend and how soon they return. YUXEL builds the marketing system behind those three numbers — positioning, demand generation, guest lifecycle and the analytics to steer them — so growth stops depending on a good month.",
    "cover": "https://images.pexels.com/photos/18501410/pexels-photo-18501410.jpeg?auto=compress&cs=tinysrgb&w=1600",
    "pillars": [
      {
        "t": "Positioning & concept",
        "d": "A concept and brand story guests can retell — the reason to choose you over the place next door."
      },
      {
        "t": "Guest acquisition",
        "d": "Digital campaigns, local demand and partnerships engineered to fill the room on the days that matter."
      },
      {
        "t": "Repeat visits & lifecycle",
        "d": "Loyalty mechanics, CRM and communication rhythms that turn first visits into habits."
      },
      {
        "t": "Sales & analytics",
        "d": "Average check, frequency and channel performance on one dashboard — decisions on numbers, not on feel."
      }
    ],
    "stats": [
      {
        "v": "Frequency",
        "l": "Guests returning sooner"
      },
      {
        "v": "Spend",
        "l": "Higher average check"
      },
      {
        "v": "Flow",
        "l": "Fuller rooms on weak days"
      }
    ],
    "serviceSlugs": [
      "brand-strategy",
      "marketing-strategy",
      "product-offer-strategy",
      "business-analytics"
    ],
    "caseSlugs": [],
    "ctaTitle": "Want fuller rooms and guests who come back?",
    "ctaSub": "Book a consultation — we'll find the constraint in your guest flow and design the system that removes it."
  }
];
export const getSector = slug=>sectors.find(s=>s.slug===slug || s.azSlug===slug);
